'use strict';exports.__esModule = true;
var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);
var _reactRouter = require('react-router');


var _CompanyCard = require('./CompanyCard.scss');var styles = _interopRequireWildcard(_CompanyCard);function _interopRequireWildcard(obj) {if (obj && obj.__esModule) {return obj;} else {var newObj = {};if (obj != null) {for (var key in obj) {if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];}}newObj.default = obj;return newObj;}}function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };} // Modules

var CompanyCard = function CompanyCard(props) {
    var handleClick = function handleClick() {return _reactRouter.browserHistory.push(props.link);};

    return (
        _react2.default.createElement('div', { onClick: handleClick, className: styles.companyCell },
            _react2.default.createElement('div', { className: styles.logo },
                _react2.default.createElement('img', { src: props.logo, alt: '' })),

            _react2.default.createElement('div', { className: styles.infoBlock },
                _react2.default.createElement('div', { className: styles.companyName },
                    props.name),

                _react2.default.createElement('div', { className: styles.bottomBlock },
                    !props.isBroker && !props.isRealtorsAssociation && !props.withoutCount &&
                    _react2.default.createElement('div', { className: styles.propertiesWrapper },
                        _react2.default.createElement('div', { className: styles.iconProperties },
                            _react2.default.createElement('i', { className: 'icon icon-home' })),

                        _react2.default.createElement('div', { className: styles.count },
                            props.count),

                        _react2.default.createElement('div', { className: styles.text },
                            props.translate('professionals', 'properties'))),



                    _react2.default.createElement('div', { className: styles.buttonWrapper },
                        _react2.default.createElement('button', { onClick: handleClick },
                            props.translate('professionals', 'moreDetails')))))));






}; // Styles

CompanyCard.propTypes = {
    translate: _propTypes2.default.func,
    name: _propTypes2.default.string,
    logo: _propTypes2.default.string,
    link: _propTypes2.default.string,
    count: _propTypes2.default.number,
    isBroker: _propTypes2.default.bool,
    isRealtorsAssociation: _propTypes2.default.bool,
    withoutCount: _propTypes2.default.bool };exports.default =


CompanyCard;module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/СompanyСard/CompanyCard.js
// module id = 2908
// module chunks = 0